import React from 'react';

const SelectionBox = ({ selectionBox }) => {
  if (!selectionBox) return null;

  const style = {
    left: Math.min(selectionBox.startX, selectionBox.currentX),
    top: Math.min(selectionBox.startY, selectionBox.currentY),
    width: Math.abs(selectionBox.currentX - selectionBox.startX),
    height: Math.abs(selectionBox.currentY - selectionBox.startY)
  };

  return (
    <div
      className="absolute bg-blue-500/10 border border-blue-500 z-[100] pointer-events-none"
      style={style}
    />
  );
};

export default SelectionBox;
